import { render, staticRenderFns } from "./EcommerceProductCategoryList.vue?vue&type=template&id=d1358962&scoped=true&lang=pug&"
import script from "./EcommerceProductCategoryList.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcommerceProductCategoryList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EcommerceProductCategoryList.vue?vue&type=style&index=0&id=d1358962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1358962",
  null
  
)

export default component.exports